import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var studioContentIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.441 10.61-2.14-1.59a1.785 1.785 0 0 0-1.883-.168c-.61.304-.992.925-.988 1.609v3.2a1.79 1.79 0 0 0 .988 1.609c.61.304 1.34.238 1.883-.168l2.14-1.614c.457-.34.72-.867.72-1.437 0-.57-.263-1.102-.72-1.442m-.902 1.68L11.4 13.9a.271.271 0 0 1-.31.03.29.29 0 0 1-.16-.269v-3.2a.281.281 0 0 1 .301-.288c.051 0 .11.02.168.058l2.141 1.59c.102.078.121.18.121.239 0 .062-.012.16-.12.242"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.031 5.531a6.516 6.516 0 0 0-6.511 6.508 6.52 6.52 0 0 0 6.511 6.512c3.59 0 6.508-2.922 6.508-6.512a6.513 6.513 0 0 0-6.508-6.508m0 11.52a5.02 5.02 0 0 1-5.011-5.012 5.019 5.019 0 0 1 5.011-5.008 5.018 5.018 0 0 1 5.008 5.008 5.019 5.019 0 0 1-5.008 5.012"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 0H4a1.5 1.5 0 0 0-1.5 1.5v21A1.5 1.5 0 0 0 4 24h16a1.5 1.5 0 0 0 1.5-1.5v-21A1.5 1.5 0 0 0 20 0zm0 22.5H4v-21h5.762v.11c0 .628.508 1.14 1.136 1.14h2.23a1.14 1.14 0 0 0 1.142-1.14V1.5H20zm0 0"
}));

export { studioContentIcon as default };
//# sourceMappingURL=studioContentIcon.js.map
